// extracted by mini-css-extract-plugin
var _1 = "selfCheck-module_inputHiden__yXiVcN";
var _2 = "selfCheck-module_inputlabel__IzSI1a";
export { _1 as "inputHiden", _2 as "inputlabel" }
